.cardGrid {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-top: 1.5rem;
}

.categorySection {
  margin-top: 1.5rem;
}

.categorySection:first-child {
  margin-top: 0;
}

.categoryHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.5rem 0;
  font-size: var(--font-size-subtitle);
  font-weight: 600;
  color: var(--section-header-text-color);
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}

.categoryHeader:hover {
  color: var(--header-text-color);
}

.categoryHeaderText {
  flex: 1;
}

.chevron {
  color: var(--muted-text);
  flex-shrink: 0;
}

.categoryHeader:hover .chevron {
  color: var(--main-text);
}

.categoryCards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
  margin-top: 0.5rem;
}

.card {
  display: block;
  padding: 1.25rem;
  background: var(--item-background);
  border: 1px solid var(--item-border);
  border-radius: 8px;
  text-decoration: none;
  color: var(--main-text);
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease;
}

.card:hover {
  border-color: var(--item-hover-border);
  background: var(--item-hover-background);
}

.cardTitle {
  font-size: 1.0625rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: var(--main-text);
}

.cardDescription {
  font-size: 0.875rem;
  line-height: 1.4;
  color: var(--muted-text);
  margin: 0;
}
